'use client';

import React from 'react';
import CaromaHubTradelinkComponent from '@/components/organisms/caroma-hub-tradelink';
const CaromaHubTradelink = ({data}: any) => {
    const caromaHubTradelinkData = data.data.dataSource;
    
    return <CaromaHubTradelinkComponent caromaHubTradelinkData={caromaHubTradelinkData} />
};

export default CaromaHubTradelink;